export function obfuscateEmail(email) {
    const [username, domain] = email.split('@');
    return `${username.charAt(0)}**@${domain}`;
}